import React from 'react'
import {connect} from 'react-redux'
import {IntlProvider} from 'react-intl'
import {localeSelectors, localeActions} from 'data/reducers/locale'
import {HasDataProviderContext} from 'data/DataProvider'
import _ from 'lodash'
import fetchJSON from 'lib/fetchJSON'

const SetLocaleContext = React.createContext(() => {})
const LOCALSTORAGE_KEY = 'preferred_locale'

export const withSetLocale = Component => props => (
  <SetLocaleContext.Consumer>
    {(setLocale) => <Component setLocale={setLocale} {...props} />}
  </SetLocaleContext.Consumer>
)

const languageStrings = {
  // since our default messages are all in English, the 'en' locale
  // will always be empty
  en: {},
  es: require('langs/es.json'),
  fr: require('langs/fr.json'),
  // Dummy marklar language. This is useful to double-check that you've covered
  // all the strings in a file before creating a Gengo translation order. To
  // regenerate the mz.json file, run `yarn translations:marklar`.
  //
  // If any of the strings are not marklar after you've regenerated the file,
  // then you know that you missed some spots.
  mz: require('langs/mz.json')
}

class _LocaleProvider extends React.PureComponent {
  render () {
    const {children, locale, language, setLocale} = this.props
    const messages = languageStrings[language] || {}

    return (
      <IntlProvider locale={locale} defaultLocale='en-US' messages={messages} key={locale}>
        <SetLocaleContext.Provider value={setLocale}>
          {children}
        </SetLocaleContext.Provider>
      </IntlProvider>
    )
  }
}

const mapStateToProps = (state) => ({
  locale: localeSelectors.locale(state),
  language: localeSelectors.language(state)
})

const mapDispatchToProps = {
  setLocale: localeActions.setLocale
}

const ConnectedLocaleProvider = connect(
  mapStateToProps,
  mapDispatchToProps
)(_LocaleProvider)

const localeFromPrefs = _.get(window, 'rwgps.config.currentUser.preferences.locale')
const localeFromLocalStorage = window && window.localStorage && window.localStorage.getItem(LOCALSTORAGE_KEY)

class StandaloneLocaleProvider extends React.PureComponent {
  static defaultProps = {
    locale: localeFromPrefs || localeFromLocalStorage || 'en',
    language: (localeFromPrefs || localeFromLocalStorage || 'en').slice(0, 2)
  }

  setLocale = (newLocale) => {
    fetchJSON('/set_preference.json', {key: 'locale', value: newLocale})
      .then(() => window.location.reload())
  }

  render () {
    const {children, locale, language} = this.props
    const messages = languageStrings[language] || {}

    return (
      <IntlProvider locale={locale} defaultLocale='en-US' messages={messages} key={locale}>
        <SetLocaleContext.Provider value={this.setLocale}>
          {children}
        </SetLocaleContext.Provider>
      </IntlProvider>
    )
  }
}

export class LocaleProvider extends React.PureComponent {
  render () {
    return (
      <HasDataProviderContext.Consumer>{hasDataProvider => hasDataProvider ? <ConnectedLocaleProvider {...this.props} /> : <StandaloneLocaleProvider {...this.props} />}</HasDataProviderContext.Consumer>
    )
  }
}
